






























































import Vue from 'vue';
import GNBNavigationButton from './GNBNavigationButton.vue';
import GNBText from './GNBText.vue';
import { axiosApiInstance } from '../../../utils/axiosInstances';
import { showUnsupportedMessage } from '@/utils/demoUtils';

export default Vue.extend({
  components: {
    GNBNavigationButton,
    GNBText,
  },
  data(): {
    leftText: string[];
    midText: string[];
    isDashboard: boolean;
  } {
    const midText = [
      '개요',
      '대시보드',
      '데이터셋 에러 목록',
      '라벨셋 에러 목록',
      '상세 그래프',
      '유사도 분석 결과',
      '품질 리포트',
    ];

    return {
      leftText: [],
      midText: midText,
      isDashboard: false,
    };
  },
  watch: {
    $route() {
      this.updateGNBDirectory();
    },
  },
  methods: {
    /**
     * GNB의 midText에 대하여, 각 버튼의 표시 여부를 결정짓는 함수
     */
    checkRenderOrNot(index: number): boolean {
      /** 라벨셋 대시보드가 아닌 경우 라벨셋과 관련된 버튼 표시 X */
      const labelsetChecker =
        this.$route.params.labelsetId === undefined &&
        (index == 3 || index == 4 || index === 6);

      /** 유사도 측정 결과가 없는 경우 유사도 관련 버튼 표시 X */
      const similarityChecker =
        !this.$store.getters.similarityAnalysis && index == 5;

      return !(labelsetChecker || similarityChecker);
    },
    onClickHomeIcon(): void {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
    onClickSignOutButton(): void {
      this.$router.push('/demo');

      // showUnsupportedMessage(this.$toast);

      // if (confirm('로그아웃 하시겠습니까?')) {
      //   this.$store.commit('setSignOut');
      //   this.$router.push('/login');
      // }
    },
    onClickGNBNavigationButton(navigationInfo: {
      navigationLocation: string;
      navigationIndex: number;
    }) {
      if (navigationInfo.navigationLocation == 'left') {
        if (navigationInfo.navigationIndex !== this.leftText.length - 1) {
          const parsedURL = this.$route.path.split('/');
          parsedURL.pop();
          if (parsedURL[parsedURL.length - 1] === 'analysis') {
            parsedURL.pop();
          }

          if (navigationInfo.navigationIndex <= 1) {
            const newGNBDirectory = this.leftText;
            while (
              newGNBDirectory.length !==
              navigationInfo.navigationIndex + 1
            ) {
              newGNBDirectory.pop();
            }

            parsedURL.pop();
            parsedURL.pop();

            this.$router.push(parsedURL.join('/'));
          }
        }
      } else if (navigationInfo.navigationLocation == 'mid') {
        const currentPath = this.$route.path.split('/');
        currentPath.pop();
        if (currentPath[currentPath.length - 1] === 'analysis') {
          currentPath.pop();
        }

        switch (navigationInfo.navigationIndex) {
          case 0: {
            currentPath.push('overview');
            break;
          }
          case 1: {
            currentPath.push('dashboard');
            break;
          }
          case 2: {
            currentPath.push('analysis/dataset');
            break;
          }
          case 3: {
            currentPath.push('analysis/labelset');
            break;
          }
          case 4: {
            currentPath.push('graph');
            break;
          }
          case 5: {
            currentPath.push('similarity');
            break;
          }
          case 6: {
            currentPath.push('report');
            break;
          }
        }

        if (this.$route.path !== currentPath.join('/')) {
          this.$router.push(currentPath.join('/'));
        }
      }
    },
    async updateGNBDirectory() {
      const newGNBDirectory: string[] = [];
      const parsedURL = this.$route.path.split('/');

      if (parsedURL.includes('workspace')) {
        const workspaceId: string =
          parsedURL[parsedURL.indexOf('workspace') + 1];

        const response = await axiosApiInstance.get(
          `/api/v1/workspaces/${workspaceId}`,
        );
        newGNBDirectory.push(response.data.result.name);
      }

      if (parsedURL.includes('dataset')) {
        const datasetId: string = parsedURL[parsedURL.indexOf('dataset') + 1];

        const response = await axiosApiInstance.get(
          `/api/v1/datasets/${datasetId}`,
        );

        newGNBDirectory.push(response.data.result.name);
      }

      if (parsedURL.includes('labelset')) {
        const labelsetId: string = parsedURL[parsedURL.indexOf('labelset') + 1];

        const response = await axiosApiInstance.get(
          `/api/v1/labelsets/${labelsetId}`,
        );
        newGNBDirectory.push(response.data.result.name);
      }

      this.leftText = newGNBDirectory;
    },
  },
  created() {
    this.updateGNBDirectory();
  },
  mounted() {
    if ((this.$refs.GNB as HTMLDivElement).classList.contains('dashboard')) {
      this.isDashboard = true;
    }
  },
  computed: {
    midSelectedIndex(): number {
      const currentViewName =
        this.$route.path.split('/')[this.$route.path.split('/').length - 1];
      if (currentViewName === 'overview') {
        return 0;
      } else if (currentViewName === 'dashboard') {
        return 1;
      } else if (currentViewName === 'dataset') {
        return 2;
      } else if (currentViewName === 'labelset') {
        return 3;
      } else if (currentViewName === 'graph') {
        return 4;
      } else if (currentViewName === 'similarity') {
        return 5;
      } else {
        return 6;
      }
    },
  },
});
